<div id="page">
  <h1 class="mat-display-1"><button mat-mini-fab color="accent" routerLink="/admin/locations/facility/{{locationID}}/units/">
    <mat-icon svgIcon="arrow_back"></mat-icon></button>{{unit$.name}} Detail View <button mat-icon-button><mat-icon aria-label="Reload Unit List" (click)="refresh()" >cached</mat-icon></button></h1>
<portalNG-PNSTable [tableData]="this.summaries$" [columnConfiguration]="this.columnConfiguration" [filters]="this.filters" (complexFilter)="filter($event)"></portalNG-PNSTable>
</div>
